import React from "react";
import "../../App.css";
import amalfi1 from "./IMGsmall/amalfi1.jpg";
import amalfi2 from "./IMGsmall/amalfi2.jpg";
import amalfi3 from "./IMGsmall/amalfi3.jpg";
import Footer from "./Footer";

export default function Italy() {
  return (
    <>
      <div class="italy">
        <h1>AMALFI COAST</h1>
        <div class="IMGsmoll">
          <img class="amalfi" alt="tree" src={amalfi1} />
          <img class="amalfi" alt="path" src={amalfi2} />
          <img class="amalfi" alt="grove" src={amalfi3} />
        </div>
      </div>
      <Footer />
    </>
  );
}
